export const TOKEN_EDIT = 'edit';
export const TOKEN_INSERT = 'insert';